import gql from 'graphql-tag';

const UPDATE_INITIAL_CREDITS_DEVICE = gql`
  mutation Mutation($deviceSerialNo: String!, $initialCreditsAttached: Float!) {
    updateInitialCredits(deviceSerialNo: $deviceSerialNo, initialCreditsAttached: $initialCreditsAttached) {
      code
    }
  }
`;

export default UPDATE_INITIAL_CREDITS_DEVICE;
